import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

// sub-systems
import {SgaWrapper} from '../pages/sga/index'
import {SgcWrapper} from '../pages/sgc/index'
import {SgtWrapper} from '../pages/sgt/index'
import {SgoWrapper} from '../pages/sgo/index'
import {IfcWrapper} from '../pages/ifc/index'

// cadastros
import {ProviderWrapper} from '../pages/register/provider/index'
import {ProjectWrapper} from '../pages/register/project/index'
import {MeasurementUnitsWrapper} from '../pages/register/measurement_units/index'
import {EnterprisesPage} from '../pages/register/enterprises/index'
import {EntrepreneursWrapper} from '../pages/register/entrepreneurs/index'
import {ReleasesWrapper} from '../pages/register/releases/index'
import {UsersWrapper} from '../pages/register/users/index'
import {ProductsWrapper} from '../pages/register/products/index'
import {CostCenterWrapper} from '../pages/register/costCenter/index'
import {EnterprisesTypesWrapper} from '../pages/register/enterprises_types/index'
import {CloudCategory} from '../pages/cloud/cloudcategory/index'
import {CloudFile} from '../pages/cloud/cloudfile/index'
import {HistoryWrapper} from '../pages/register/history/index'
import {LicensesPage} from '../pages/sga/licenses/index'
import {RolesPage} from '../pages/register/roles/index'
import {ConditioningPage} from '../pages/sga/conditioning/index'
import {ActionPlansPage} from '../pages/sga/actionPlans/index'
import {IssueOrgansWrapper} from '../pages/register/issue_organs/index'
import {FieldsPage} from '../pages/register/fields/index'
import {IndemnityItemPage} from '../pages/sgt/indemnityitem/index'
import {ContractsPage} from '../pages/sgt/contract/index'
import {ApplicationsWrapper} from '../pages/administrator/applications/index'
import {ApplicationsViewWrapper} from '../pages/applicationsView/index'
import {ParameterWrapper} from '../pages/administrator/parameter/index'

// ADD
import {AddEnterprises} from '../pages/register/enterprises/pages/addEnterprises/index'
import {AddEnterprisesType} from '../pages/register/enterprises_types/pages/addEnterprisesType/index'
import {AddEntrepreneurs} from '../pages/register/entrepreneurs/pages/addEntrepreneurs/index'
import {AddProducts} from '../pages/register/products/pages/addProducts/index'
import {AddCostCenter} from '../pages/register/costCenter/pages/addCostCenter/index'
import {AddMeasurementUnits} from '../pages/register/measurement_units/pages/addMeasurementUnits/index'
import {AddProject} from '../pages/register/project/pages/addProject/index'
import {AddProvider} from '../pages/register/provider/pages/addProvider/index'
import {AddReleases} from '../pages/register/releases/pages/addReleases/index'
import {AddUsers} from '../pages/register/users/pages/addUsers/index'
import {AddCloudCategory} from '../pages/cloud/cloudcategory/pages/addCloud/index'
import {AddCloudFile} from '../pages/cloud/cloudfile/pages/addCloud/index'
import {AddRoles} from '../pages/register/roles/pages/addRoles/index'
import {AddLicenses} from '../pages/sga/licenses/pages/addLicenses/index'
import {AddConditioning} from '../pages/sga/conditioning/pages/addConditioning/index'
import {AddIssueOrgans} from '../pages/register/issue_organs/pages/addIssueOrgans/index'
import {AddFields} from '../pages/register/fields/pages/addFields/index'
import {AddActionPlans} from '../pages/sga/actionPlans/pages/addActionPlans/index'
import {AddIndemnityItems} from '../pages/sgt/indemnityitem/pages/addIndemnityItems/index'
import {AddContracts} from '../pages/sgt/contract/pages/addContracts/index'
import {AddContractPayment} from '../pages/sgt/contract/pages///addContractPayment///index'
import {AddApplications} from '../pages/administrator/applications/pages/addApplications/index'
//FIM ADD

//EDIT
import {EditEnterprises} from '../pages/register/enterprises/pages/editEnterprises/index'
import {EditEnterprisesType} from '../pages/register/enterprises_types/pages/editEnterprisesType/index'
import {EditEntrepreneurs} from '../pages/register/entrepreneurs/pages/editEntrepreneurs/index'
import {EditProducts} from '../pages/register/products/pages/editProducts/index'
import {EditCostCenter} from '../pages/register/costCenter/pages/editCostCenter/index'
import {EditMeasurementUnits} from '../pages/register/measurement_units/pages/editMeasurementUnits/index'
import {EditProject} from '../pages/register/project/pages/editProject/index'
import {EditProvider} from '../pages/register/provider/pages/editProvider/index'
import {EditReleases} from '../pages/register/releases/pages/editReleases/index'
import {EditUsers} from '../pages/register/users/pages//editUsers/index'
import {EditCloudCategory} from '../pages/cloud/cloudcategory/pages/editCloud'
import {EditCloudFile} from '../pages/cloud/cloudfile/pages/editCloud/index'
import {EditRoles} from '../pages/register/roles/pages/editRoles/index'
import {EditLicenses} from '../pages/sga/licenses/pages//editLicenses//index'
import {EditConditioning} from '../pages/sga/conditioning/pages/editConditioning/index'
import {EditProvidence} from '../pages/sga/providence/pages/editProvidence/index'
import {EditActionPlans} from '../pages/sga/actionPlans/pages/editActionPlans/index'
import {EditIssueOrgans} from '../pages/register/issue_organs/pages/editIssueOrgans/index'
import {EditIndemnityItems} from '../pages/sgt/indemnityitem/pages/editIndemnityItems/index'
import {EditContracts} from '../pages/sgt/contract/pages/editContracts/index'
import {EditApplications} from '../pages/administrator/applications/pages/editApplications/index'
import {EditEnterpriseName} from '../pages/administrator/parameter/pages/editEnterpriseName/index'
import {EditLogoWhite} from '../pages/administrator/parameter/pages/editLogoWhite/index'
import {EditLogoBlack} from '../pages/administrator/parameter/pages/editLogoBlack/index'
import {EditParameterLicense} from '../pages/administrator/parameter/pages///editParameterLicense////index'
import {EditParameterProvidence} from '../pages/administrator/parameter/pages///editParameterProvidence////index'
import {EditParameterConditioning} from '../pages/administrator/parameter/pages/editParameterConditioning/index'
import {EditParameterActionPlan} from '../pages/administrator/parameter/pages////editParameterActionPlan/////index'

// FIM EDIT
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {AddProvidence} from '../pages/sga/providence/pages/addProvidence'
import {RenewLicence} from '../pages/sga/licenses/pages/renewLicense'
import {AddOwner} from '../pages/sgt/owner/pages/addOwner'
import {EditOwner} from '../pages/sgt/owner/pages/editOwner'

import {OwnerListWrapper} from '../pages/sgt/owner/components/owner-list/OwnerList'

import {AddPricingTable} from '../pages/sga/pricing_table/pages/addPricingTable'
import {AddLicenseTypes} from '../pages/sga/license_types/pages/addLicenseTypes'
import {EditLicenseTypes} from '../pages/sga/license_types/pages/editLicenseTypes'
import {LicenseTypesListWrapper} from '../pages/sga/license_types/components/license_types-list/LicenseTypesList'
import {PropertiesPage} from '../pages/sgt/property'
import {AddProperties} from '../pages/sgt/property/pages/addProperties/AddProperties'
import {EditProperties} from '../pages/sgt/property/pages/editProperties'
import {AddEvaluationReport} from '../pages/sgt/evaluationReport/pages/addEvaluationReport'
import {EditEvaluationReport} from '../pages/sgt/evaluationReport/pages/editEvaluationReport'
import {EvaluationReportPage} from '../pages/sgt/evaluationReport'
import {EditeFields} from '../pages/register/fields/pages/editFields'
import {EditPricingTable} from '../pages/sga/pricing_table/pages/editPricingTable'
import {PricingTablesWrapper} from '../pages/sga/pricing_table'
import {ProvidencePage} from '../pages/sga/providence'

const PrivateRoutes = () => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/' />} />
        {/* Pages */}
        <Route path='/sga' element={<SgaWrapper />} />
        <Route path='/sgt' element={<SgtWrapper />} />
        <Route path='/sgc' element={<SgcWrapper />} />
        <Route path='/sgo' element={<SgoWrapper />} />
        <Route path='/ifc' element={<IfcWrapper />} />
        <Route path='providers' element={<ProviderWrapper />} />
        <Route path='projects' element={<ProjectWrapper />} />
        <Route path='measurement_units' element={<MeasurementUnitsWrapper />} />
        <Route path='enterprises' element={<EnterprisesPage />} />
        <Route path='entrepreneurs' element={<EntrepreneursWrapper />} />
        <Route path='products' element={<ProductsWrapper />} />
        <Route path='costcenters' element={<CostCenterWrapper />} />
        <Route path='pricingtable/:uuid' element={<PricingTablesWrapper />} />
        <Route path='license_types' element={<LicenseTypesListWrapper />} />
        <Route path='enterprises_type' element={<EnterprisesTypesWrapper />} />
        <Route path='releases' element={<ReleasesWrapper />} />
        <Route path='users' element={<UsersWrapper />} />
        <Route path='cloudcategory' element={<CloudCategory />} />
        <Route path='cloudfile' element={<CloudFile />} />
        <Route path='/historylogs' element={<HistoryWrapper />} />
        <Route path='/licenses' element={<LicensesPage />} />
        <Route path='roles' element={<RolesPage />} />
        <Route path='conditioning' element={<ConditioningPage />} />
        <Route path='conditioning/:tab' element={<ConditioningPage />} />
        <Route path='actionplans' element={<ActionPlansPage />} />
        <Route path='providences' element={<ProvidencePage />} />
        <Route path='issueorgans' element={<IssueOrgansWrapper />} />
        <Route path='fields' element={<FieldsPage />} />
        <Route path='renewlicence/:uuid' element={<RenewLicence />} />
        <Route path='owners' element={<OwnerListWrapper />} />
        <Route path='properties' element={<PropertiesPage />} />
        <Route path='indemnityitem' element={<IndemnityItemPage />} />
        <Route path='contracts' element={<ContractsPage />} />
        <Route path='evaluationreports' element={<EvaluationReportPage />} />
        <Route path='applications' element={<ApplicationsWrapper />} />
        <Route path='applicationsview' element={<ApplicationsViewWrapper />} />
        <Route path='parameters' element={<ParameterWrapper />} />

        {/* ADD */}
        <Route path='addenterprises' element={<AddEnterprises />} />
        <Route path='addenterprises_types' element={<AddEnterprisesType />} />
        <Route path='addentrepreneurs' element={<AddEntrepreneurs />} />
        <Route path='addproducts' element={<AddProducts />} />
        <Route path='addcostcenter' element={<AddCostCenter />} />
        <Route path='addpricingtable/:uuid' element={<AddPricingTable />} />
        <Route path='addlicense_types' element={<AddLicenseTypes />} />
        <Route path='addmeasurement_units' element={<AddMeasurementUnits />} />
        <Route path='addproject' element={<AddProject />} />
        <Route path='addprovider' element={<AddProvider />} />
        <Route path='addreleases' element={<AddReleases />} />
        <Route path='addusers' element={<AddUsers />} />
        <Route path='addcloud_category' element={<AddCloudCategory />} />
        <Route path='addcloud_file' element={<AddCloudFile />} />
        <Route path='addroles' element={<AddRoles />} />
        <Route path='addlicenses' element={<AddLicenses />} />
        <Route path='addconditioning/:id/:uuid' element={<AddConditioning />} />
        <Route path='addprovidence/:uuid' element={<AddProvidence />} />
        <Route path='addissueorgans' element={<AddIssueOrgans />} />
        <Route path='addfields' element={<AddFields />} />
        <Route path='addactionplans/:project_id/:uuid' element={<AddActionPlans />} />
        <Route path='addactionplans/:uuid' element={<AddActionPlans />} />
        <Route path='addowners' element={<AddOwner />} />
        <Route path='addproperties' element={<AddProperties />} />
        <Route path='addindemnityitems' element={<AddIndemnityItems />} />
        <Route path='addcontracts' element={<AddContracts />} />
        <Route path='addevaluationreport/:id' element={<AddEvaluationReport />} />
        <Route path='addcontractpayment/:uuid' element={<AddContractPayment />} />
        <Route path='addapplications' element={<AddApplications />} />
        {/* FIM ADD */}

        {/* EDIT */}
        <Route path='editenterprises' element={<EditEnterprises />} />
        <Route path='editenterprises_types' element={<EditEnterprisesType />} />
        <Route path='editentrepreneurs' element={<EditEntrepreneurs />} />
        <Route path='editproducts' element={<EditProducts />} />
        <Route path='editcostcenter' element={<EditCostCenter />} />
        <Route path='editpricingtable' element={<EditPricingTable />} />
        <Route path='editpricingtable/:uuid' element={<EditPricingTable />} />
        <Route path='editlicense_types' element={<EditLicenseTypes />} />
        <Route path='editmeasurement_units' element={<EditMeasurementUnits />} />
        <Route path='editproject' element={<EditProject />} />
        <Route path='editprovider' element={<EditProvider />} />
        <Route path='editreleases' element={<EditReleases />} />
        <Route path='editusers' element={<EditUsers />} />
        <Route path='editcloud_category' element={<EditCloudCategory />} />
        <Route path='editcloud_file' element={<EditCloudFile />} />
        <Route path='editroles' element={<EditRoles />} />
        <Route path='editlicenses/:uuid' element={<EditLicenses />} />
        <Route path='editlicenses/:id/:uuid/' element={<EditLicenses />} />
        <Route path='editconditioning/:id/:uuid/:uuid2' element={<EditConditioning />} />
        {/* <Route path='editconditioning/:uuid/:uuid2' element={<EditConditioning />} /> */}
        <Route path='editprovidence/:uuid/:uuid2' element={<EditProvidence />} />
        <Route path='editprovidence/:id/:uuid/:uuid2' element={<EditProvidence />} />
        <Route path='editactionplans/:uuid/:uuid2' element={<EditActionPlans />} />
        <Route path='editowners/:uuid' element={<EditOwner />} />
        <Route path='editproperties/:id/:uuid' element={<EditProperties />} />
        <Route path='editissueorgans/:uuid' element={<EditIssueOrgans />} />
        <Route path='editindemnityitems' element={<EditIndemnityItems />} />
        <Route path='editcontracts/:uuid' element={<EditContracts />} />
        <Route path='editcontracts/:id/:uuid' element={<EditContracts />} />
        <Route path='editevaluationreport/:uuid' element={<EditEvaluationReport />} />
        <Route path='editefields/:uuid' element={<EditeFields />} />
        <Route path='editapplications' element={<EditApplications />} />
        {/* <Route path='editparameters' element={<EditEnterpriseName/>} /> */}
        <Route path='editenterprisename' element={<EditEnterpriseName />} />
        <Route path='editlogowhite' element={<EditLogoWhite />} />
        <Route path='editlogoblack' element={<EditLogoBlack />} />
        <Route path='editparameterlicense' element={<EditParameterLicense />} />
        <Route path='editparameterconditioning' element={<EditParameterConditioning />} />
        <Route path='editparameterprovidence' element={<EditParameterProvidence />} />
        <Route path='editparameteractionplan' element={<EditParameterActionPlan />} />

        {/* FIM EDIT */}
        <Route index element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
